export class HttpResponse {
  isSuccess: boolean;
  payLoad: any;
}

export interface PersonData {
  type: string;
  firstName: string;
  lastName: string;
  birthDate: any;
  communicationChannels: CommunicationChannel[];
}

export interface CommunicationChannel {
  id: any;
  typeId: string;
  content: any;
  label: string;
}

export class Doctor {
  doctorId: string;
  name: string;
  isDoctor: boolean;

  constructor(obj?: any) {
    this.doctorId = (obj && obj.id) || null;
    this.name = (obj && obj.name) || "";
    this.isDoctor = (obj && obj.uid) || false;
  }
}

export class AppointmentType {
  id: string;
  name: string;
  description: string;
  uid: string;

  constructor(obj?: any) {
    this.id = (obj && obj.id) || null;
    this.name = (obj && obj.name) || "";
    this.uid = (obj && obj.uid) || null;
    this.description = (obj && obj.description) || null;
  }
}

export class PotentialAppointmentListModel {
  weekDay: string;
  date: any;
  potentialAppointments: PotentialAppointmentSlot[];

  constructor(obj?: any) {
    this.date = (obj && obj.date) || null;
    this.potentialAppointments =
      (obj &&
        obj.potentialAppointments &&
        this.createPotentialAppointments(obj.potentialAppointments)) ||
      [];
  }

  createPotentialAppointments(
    items: PotentialAppointmentSlot[]
  ): PotentialAppointmentSlot[] {
    let potentialAppointments = [];
    items.forEach((item) =>
      potentialAppointments.push(new PotentialAppointmentSlot(item))
    );
    return potentialAppointments;
  }
}
export interface RegistrationData {
  firstName: string;
  lastName: string;
  birthDate: string;
  telNumber: string;
  email: string;
}

export interface QueryParams {
  widgetUid: string;
  languageIsoCode: string;
  dates: Array<string>;
  appointmentTypeUid: string;
  doctorId: string;
}

export class PotentialAppointmentSlot {
  id: string;
  appointmentTypeUid: string;
  appointmentTypeVariationId: string;
  appointmentTypeVariationUid: string;
  isDefault: boolean;
  //name: string;
  orderSequence: number;
  //orderSequenceNumber: number;
  plannedEnd: string;
  plannedStart: string;
  plannedStartShowTime: string;
  plannedEndShowTime: string;
  shouldDisplayVariationsRandom: boolean;
  officeUid: string;
  appointmentTypeVariationName: any;
  consultationHourUid: string;
  locationOfConsultationHourFacilityUid: string;
  steps: PotentialAppointmentSlotStep[];

  constructor(obj?: any) {
    this.id = (obj && obj.id) || null;
    this.appointmentTypeUid = (obj && obj.appointmentTypeUid) || null;
    this.appointmentTypeVariationId =
      (obj && obj.appointmentTypeVariationId) || null;
    this.appointmentTypeVariationUid =
      (obj && obj.appointmentTypeVariationUid) || null;
    this.isDefault = (obj && obj.isDefault) || false;
    //this.name = obj && obj.name || null;
    this.orderSequence = (obj && obj.orderSequence) || null;
    //this.orderSequenceNumber = obj && obj.orderSequenceNumber || null;
    this.plannedEnd = (obj && obj.plannedEnd) || null;
    this.plannedStart = (obj && obj.plannedStart) || null;
    this.plannedStartShowTime = (obj && obj.plannedStartShowTime) || null;
    this.plannedEndShowTime = (obj && obj.plannedEndShowTime) || null;
    this.shouldDisplayVariationsRandom =
      (obj && obj.shouldDisplayVariationsRandom) || false;
    this.officeUid = (obj && obj.officeUid) || null;
    this.appointmentTypeVariationName =
      (obj && obj.appointmentTypeVariationName) || null;
    this.consultationHourUid = (obj && obj.consultationHourUid) || null;
    this.locationOfConsultationHourFacilityUid =
      (obj && obj.locationOfConsultationHourFacilityUid) || null;
    this.steps = (obj && obj.steps && this.createSteps(obj.steps)) || [];
  }

  createSteps(
    items: PotentialAppointmentSlotStep[]
  ): PotentialAppointmentSlotStep[] {
    let steps = [];
    items.forEach((item) => steps.push(new PotentialAppointmentSlotStep(item)));
    return steps;
  }
}

class PotentialAppointmentSlotStep {
  uid: string;
  plannedStart: string;
  plannedEnd: string;
  orderSequenceNumber: number;
  stepName: string;
  usedResources: RequiredResource[];

  constructor(obj?: any) {
    this.uid = (obj && obj.uid) || null;
    this.plannedStart = (obj && obj.plannedStart) || null;
    this.plannedEnd = (obj && obj.plannedEnd) || null;
    this.orderSequenceNumber = (obj && obj.orderSequenceNumber) || null;
    this.stepName = (obj && obj.stepName) || null;
    this.usedResources =
      (obj &&
        obj.usedResources &&
        this.createRequiredResources(obj.usedResources)) ||
      [];
  }

  createRequiredResources(items: RequiredResource[]): RequiredResource[] {
    let usedResources = [];
    items.forEach((item) => usedResources.push(new RequiredResource(item)));
    return usedResources;
  }
}

class RequiredResource {
  resourceId: string;
  requiredResourceId: string;
  resourceType: number;
  isOverbooked: boolean;

  constructor(obj?: any) {
    this.resourceId = (obj && obj.resourceId) || null;
    this.requiredResourceId = (obj && obj.requiredResourceId) || null;
    this.resourceType = obj && obj.resourceType;
    this.isOverbooked = (obj && obj.isOverbooked) || false;
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/widget.model.ts